<template>
  <div>
    <tableComponent
      class="pa-5 pl-0"
      ref="tableComponent"
      :tableSettings="tableSettings"
      :tableData="tableData"
      :headers="headers"
      :enable-row-clickable="true"
      @newDocument="newDocument"
      @clickedRow="openDetails($event)"
      @bulkUnarchive="bulkUnarchive"
      @confirmBulkDelete="confirmBulkDelete"
    />
    <employeeDetailsDialog
      ref="employeeDetailsDialog"
      v-model="isEmployeeDialogOpen"
    />
    <v-dialog v-model="bulkConfirm.open" max-width="440">
      <v-card>
        <v-card-title>{{ bulkConfirm.title }}</v-card-title>
        <v-card-text>{{ bulkConfirm.message }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="bulkConfirm.open = false"
            :disabled="bulkConfirm.loading"
          >
            {{ $t("general.cancel") }}
          </v-btn>
          <v-btn
            :color="bulkConfirm.color"
            :loading="bulkConfirm.loading"
            @click="runBulkConfirm"
          >
            {{ bulkConfirm.confirmText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getUniqueId } from "@/components/api/api";
import tableComponent from "@/components/_utils/dataTableHelpers/tableComponent.vue";
import employeeDetailsDialog from "../../components/tableSlotComponents/employee/employeeDetailsDialog.vue";
export default {
  components: {
    tableComponent,
    employeeDetailsDialog,
  },
  data: () => ({
    tableSettings: {
      title: "",
      showSelect: true,
      showHeaderToolbar: true,
      headerButtons: [],
      multipleSelectButtons: [
        {
          title: "employee.bulk.unarchiveButton",
          color: "primary",
          action: "bulkUnarchive",
          icon: "unarchive",
          iconDark: true,
          dark: true,
          outlined: true,
        },
        {
          title: "employee.bulk.deleteButton",
          color: "error",
          action: "confirmBulkDelete",
          icon: "delete",
          iconDark: true,
          dark: true,
          outlined: true,
        },
      ],
    },
    tableData: {
      tableComponentSlots: [
        {
          id: getUniqueId(),
          slotName: "item.employeeFormattedCreatedAt",
          componentName: "employeeFormattedCreatedAt",
        },
        {
          id: getUniqueId(),
          slotName: "item.employeeAction",
          componentName: "employeeAction",
        },
      ],
      itemKey: "_id",
      uriPartPrepend: "employee",
      uriPartAppend: "&archived=true",
      populate: [],
      sort: "",
      editFormPushName: "employeeForm",
    },
    isEmployeeDialogOpen: false,
    bulkConfirm: {
      open: false,
      loading: false,
      title: "",
      message: "",
      confirmText: "",
      color: "primary",
      action: null,
      ids: [],
    },
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("employee.tableHeader.name"),
          value: "name",
          align: "left",
        },
        { text: this.$t("employee.tableHeader.email"), value: "email" },
        {
          text: this.$t("employee.tableHeader.language"),
          value: "employeeLanguage",
        },
        {
          text: this.$t("employee.tableHeader.createdAt"),
          value: "employeeFormattedCreatedAt",
        },
        {
          text: "",
          value: "employeeAction",
          align: "right",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    reloadDataFunc() {
      this.$refs.tableComponent.getData();
    },
    newDocument() {
      this.$router.push({
        name: this.tableData.editFormPushName,
        params: { id: "1", mode: "new", data: 1 },
      });
    },
    openDetails(employee) {
      this.$refs.employeeDetailsDialog.data = employee;
      this.isEmployeeDialogOpen = true;
    },
    bulkUnarchive(selectedItems) {
      const ids = (selectedItems || []).map((e) => e._id);
      this.bulkConfirm = {
        open: true,
        loading: false,
        title: this.$t("employee.bulk.unarchiveTitle"),
        message: this.$t("employee.bulk.unarchiveConfirm", {
          count: ids.length,
        }),
        confirmText: this.$t("employee.bulk.unarchiveButton"),
        color: "primary",
        action: "bulkUnarchiveEmployees",
        ids,
      };
    },
    confirmBulkDelete(selectedItems) {
      const ids = (selectedItems || []).map((e) => e._id);
      this.bulkConfirm = {
        open: true,
        loading: false,
        title: this.$t("employee.bulk.deleteTitle"),
        message: this.$t("employee.bulk.deleteConfirm", { count: ids.length }),
        confirmText: this.$t("employee.bulk.deleteButton"),
        color: "error",
        action: "bulkDeleteEmployees",
        ids,
      };
    },
    async runBulkConfirm() {
      this.bulkConfirm.loading = true;
      try {
        await this.$store.dispatch(
          this.bulkConfirm.action,
          this.bulkConfirm.ids,
        );
        this.bulkConfirm.open = false;
        this.onBulkActionDone();
      } finally {
        this.bulkConfirm.loading = false;
      }
    },
    onBulkActionDone() {
      if (this.$refs.tableComponent) {
        this.$refs.tableComponent.clearSelectItems();
      }
      this.reloadDataFunc();
      this.$root.$emit("employee-stats-refresh");
    },
  },
};
</script>
